import { gql } from '@apollo/client';
import Fragments from './fragments';

export const PAGED_AUTHORIZATIONS_QUERY = gql`
  query pagedAuthorizations($pager: PagerInputNew, $filters: SecurityFilterInput) {
    pagedAuthorizations(pager: $pager, filters: $filters) {
      total
      values {
        ...authorizationItem
        authorizationXUserGroups {
          ...authorizationXUserGroup
        }
        authorizationContextType {
          ...authorizationContextType
        }
      }
    }
  }
  ${Fragments.authorizationItem}
  ${Fragments.authorizationXUserGroup}
  ${Fragments.authorizationContextType}
`;

export const AUTHORIZATIONS_FILTER_QUERY = gql`
  {
    authorizationsFilter @client {
      fullTextFilter {
        value
      }
      name {
        value
      }
    }
  }
`;

export const AUTHORIZATION_WITH_REFINES_QUERY = gql`
  query authorizationWithRefines($authorizationId: Int!) {
    authorizationWithRefines(authorizationId: $authorizationId) {
      webAuthorizationId
      name
      authorizationXDocumentTypeXUserGroups {
        ...authorizationXDocumentTypeXUserGroup
      }
    }
  }
  ${Fragments.authorizationXDocumentTypeXUserGroup}
`;

export const ALLOWED_DOCUMENT_TYPES_X_STATES_QUERY = gql`
  query allowedDocumentTypesXStates($authorizationId: Int!, $pager: PagerInputNew, $filters: AllowedDocumentTypesXStatesFilterInput) {
    allowedDocumentTypesXStates(authorizationId: $authorizationId, pager: $pager, filters: $filters) {
      total
      values {
        ...documentTypeXStateModel
      }
    }
  }
  ${Fragments.documentTypeXStateModel}
`;

export const REFINED_AUTHORIZATIONS_FILTER_QUERY = gql`
  {
    refinedAuthorizationsFilter @client {
      fullTextFilter {
        value
      }
      documentTypeName {
        value
      }
      documentStateName {
        value
      }
    }
  }
`;
